// PokeApp-Kevin Simon

import React from 'react';
import App from './pokeinfo.js';

// middlebox is css class to create grey background and black box around app
function PokemonApp() {
  return (
    <div class="middlebox">
      <h1>Hit Refresh to Meet a Random Pokemon!</h1>
      <div>
      <App />
      </div>
    </div>
  );
}

export default PokemonApp;
